var _path, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTrashFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5B3C2",
    fillRule: "evenodd",
    d: "M18.667 5.304l4.99 5.363h-4.038c-.525 0-.952-.508-.952-1.134V5.304zm7.655 4.467l-5.927-6.667c-.252-.279-.61-.437-.986-.437H8.742c-1.88 0-3.408 1.496-3.408 3.333v20c0 1.837 1.528 3.333 3.408 3.333h14.517c1.88 0 3.408-1.496 3.408-3.333V10.667c0-.332-.122-.65-.345-.896z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    width: 22,
    height: 28,
    x: 5,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.667 5.304l4.99 5.363h-4.038c-.525 0-.952-.508-.952-1.134V5.304zm7.655 4.467l-5.927-6.667c-.252-.279-.61-.437-.986-.437H8.742c-1.88 0-3.408 1.496-3.408 3.333v20c0 1.837 1.528 3.333 3.408 3.333h14.517c1.88 0 3.408-1.496 3.408-3.333V10.667c0-.332-.122-.65-.345-.896z",
    clipRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrashFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash_file.b4e78995.svg";
export { ForwardRef as ReactComponent };